import http from '@/utils/request';

/**
 * 付款审核列表
 *
 * @param {*} data
 * @returns
*/
export const getPaymentApplyList = (data = {}) => {
  const url = '/payment/apply/bopList';
  return http.post({
    url,
    data,
  });
};

/**
 * 付款审核列表-付款审核操作
 *
 * @param {*} data
 * @returns
*/
export const setPaymentApplyApproval = (data = {}) => {
  const url = '/payment/apply/approval';
  return http.post({
    url,
    data,
  });
};

/**
 * 付款审核列表-付款批量审核操作
 *
 * @param {*} data
 * @returns
*/
export const setPaymentApplyBatchApproval = (data = {}) => {
  const url = '/payment/apply/batchApproval';
  return http.post({
    url,
    data,
  });
};

/**
 * 付款审核列表-付款申请详情
 *
 * @param {*} data
 * @returns
*/
export const getPaymentApplyDetail = (data = {}) => {
  const url = '/payment/apply/detail';
  return http.post({
    url,
    data,
  });
};

// 付款审核列表-付款申请详情 - 关联应收单
export const getReceiveList = (data = {}) => {
  const url = '/payment/apply/detail/receives';
  return http.post({
    url,
    data,
  });
};

/**
 * 应付单列表-应付单详情
 *
 * @param {*} data
 * @returns
*/
export const getPaymentPayableDetail = (data = {}) => {
  const url = '/payment/payable/detail';
  return http.post({
    url,
    data,
  });
};

// 应付单-应付单详情-操作日志
export const getOperationLogList = (data = {}) => {
  return http.post({
    url: '/payment/payable/operationLogList',
    data,
  });
};
